import React, { useState, useContext, useRef } from 'react'
import './M_Button.css'
import { Tooltip } from '@mui/material'
import { M_Table, M_ElementDrawer, LoadingContext, } from '../../M_Components'
import { useTranslation } from "react-i18next"

export function M_Button({
    onClick, borderColor, backgroundColor, label, icon, labelColor,
    iconPosition, smallIcon, largeIcon, bold, hoverEffect, tooltip,
    id, width, height, borderRadius, normal, large, none, marginLeft,
    marginRight, marginTop, marginBottom, type, disabled, onGetline,
    FILTER, entity, errorMessage, tableLabel, element, disableFunction,
    inputType, onInput, marginNone, noHover, multiple, onSubmitValue,
    value, valueIdField
}) {
    const { t } = useTranslation()
    const [onOpen, setOnOpen] = useState(false)
    const [selectedRows, setSelectedRows] = useState([])
    const ctx = useContext(LoadingContext)
    const inputRef = useRef(null)

    const divImg = (
        icon &&
        <i style={{
            marginLeft: '5px',
            marginRight: '5px',
            scale: `${smallIcon ? '.5' : largeIcon ? '1.5' : '1'}`
        }}>
            {icon}
        </i>
    )

    const buttonClick = () => {
        if (disabled !== undefined && disabled !== null) {
            if (disableFunction()) {
                ctx.toastMessages('error', errorMessage, '')
            } else {
                openDrawer()
            }
        } else {
            openDrawer()
        }
    }

    const getLine = (e) => {
        if (multiple) {
            setSelectedRows(e)
        } else {
            onGetline(e[0])
            closeDrawer()
        }
    }

    const openDrawer = () => {
        setOnOpen(true)
        setSelectedRows([])
    }

    const closeDrawer = () => {
        setOnOpen(false)
    }

    const clickFunction = (event) => {
        if (disabled) {
            if (entity || element) {
                return buttonClick()
            }
        } else {
            if (inputType) {
                return handleClickInput()
            }
            if (entity || element) {
                return buttonClick()
            } else {
                if (typeof onClick === 'function') {
                    return onClick(event)
                }
            }
        }
    }

    const styledButtons = {
        padding: `${normal ? '0px 10px' : large ? '5px 15px' : none ? '0px 0px' : width || height ? `${height ? height : 0}px ${width ? width : 5}px` : '0px 5px'}`,
        border: `${borderColor ? `1px solid ${borderColor}` : '0px'}`,
        backgroundColor: backgroundColor ? backgroundColor : "var(--color-white)",
        color: labelColor ? labelColor : "var(--color-black)",
        fontWeight: bold ? "bold" : "",
        borderRadius: borderRadius ? `${borderRadius}px` : "5px",
        marginLeft: marginLeft ? `${marginLeft}px` : marginNone ? '0px' : "5px",
        marginRight: marginRight ? `${marginRight}px` : marginNone ? '0px' : "5px",
        marginTop: marginTop ? `${marginTop}px` : marginNone ? '0px' : "5px",
        marginBottom: marginBottom ? `${marginBottom}px` : marginNone ? '0px' : "5px",
    }

    const styledLabel = {
        marginTop: marginNone ? '0px' : '10px',
        marginBottom: marginNone ? '0px' : '10px',
        marginLeft: marginNone ? '0px' : '5px',
        marginRight: marginNone ? '0px' : '5px',
    }

    const disableStyledButtons = {
        padding: `${normal ? '0px 10px' : large ? '5px 15px' : none ? '0px 0px' : width || height ? `${height ? height : 0}px ${width ? width : 5}px` : '0px 5px'}`,
        border: `${borderColor ? `1px solid ${borderColor}` : '0px'}`,
        backgroundColor: backgroundColor ? backgroundColor : "var(--color-white)",
        color: labelColor ? labelColor : "var(--color-black)",
        fontWeight: bold ? "bold" : "",
        borderRadius: borderRadius ? `${borderRadius}px` : "5px",
        marginLeft: marginLeft ? `${marginLeft}px` : marginNone ? '0px' : "5px",
        marginRight: marginRight ? `${marginRight}px` : marginNone ? '0px' : "5px",
        marginTop: marginTop ? `${marginTop}px` : marginNone ? '0px' : "5px",
        marginBottom: marginBottom ? `${marginBottom}px` : marginNone ? '0px' : "5px",
        boxShadow: 'inset 100px 100px 10px var(--color-grey-light)'
    }

    const handleClickInput = () => {
        inputRef.current.click()
    }

    const onSave = (e) => {
        onSubmitValue(e)
        closeDrawer()
    }

    return (
        <div draggable={false} onDragStart={(event) => event.preventDefault()} id={id}>
            {tooltip ?
                <Tooltip onClick={clickFunction} title={tooltip}>
                    <button disabled={disabled} type={type} style={disabled ? disableStyledButtons : styledButtons} className={`${disabled ? "buttonClass2" : hoverEffect ? "buttonClass buttonClassHover hoverEffect" : noHover ? "buttonClass" : "buttonClass buttonClassHover"}`} >
                        {!iconPosition || iconPosition.toUpperCase() === 'LEFT' ? divImg : ''}
                        {label && <span className='fontSizeLabel' style={styledLabel} >{label}</span>}
                        {iconPosition && iconPosition.toUpperCase() === 'RIGHT' && divImg}
                    </button>
                </Tooltip>
                :
                <button disabled={disabled} type={type} onClick={clickFunction} style={disabled ? disableStyledButtons : styledButtons} className={`${disabled ? "buttonClass2" : hoverEffect ? "buttonClass buttonClassHover hoverEffect" : noHover ? "buttonClass" : "buttonClass buttonClassHover"}`}>
                    {!iconPosition || iconPosition.toUpperCase() === 'LEFT' ? divImg : ''}
                    {label && <span className='fontSizeLabel' style={styledLabel}>{label}</span>}
                    {iconPosition && iconPosition.toUpperCase() === 'RIGHT' && divImg}
                </button>
            }
            {entity &&
                <M_ElementDrawer
                    element={
                        <div className='divTableDrawer' style={{}}>
                            <h2 style={{ marginLeft: '10px', marginTop: '0px', marginBottom: '10px' }}>{tableLabel}</h2>
                            <M_Table
                                removeHeaders={['IMAGE']}
                                tableHeight={'80vh'}
                                entityName={entity}
                                useSessionStorage={false}
                                crud={false}
                                onPassLine={getLine}
                                selectSingle={multiple ? false : true}
                                FILTER={FILTER}
                                value={value}
                                valueIdField={valueIdField}
                                extraButtons={multiple && [{ label: t("Save"), element: 'default', icon: <img src="/icons/svgsDaNet/save.svg" style={{ filter: 'invert(42%) sepia(44%) saturate(4434%) hue-rotate(74deg) brightness(97%) contrast(101%)', width: '24px' }} alt="save" />, command: (e) => onSave(e) }]}
                            />
                        </div>
                    }
                    tableLabel={tableLabel || ''}
                    entity={entity}
                    open={onOpen}
                    setOpen={setOnOpen}
                    onClose={closeDrawer}
                    onSelectLine={getLine}
                    FILTER={FILTER}
                />}
            {inputType && <input
                type={inputType}
                ref={inputRef}
                onChange={onInput}
                style={{ display: 'none' }}
                aria-hidden="true"
            />}
            {element &&
                <M_ElementDrawer
                    open={onOpen}
                    setOpen={setOnOpen}
                    onClose={closeDrawer}
                    element={element}
                />}
        </div>
    )
}